<template>
    <div style="padding: 6px 0;" class="pic-news">
        <ul class="list" style="min-height: 560px">
            <li v-for="(item, index) in list" :key="index" class="item" @click="toDetail(item)">
                <img :src="item.image" alt="" />
                <div class="info">
                    <a class="title">{{ item.title }}</a>
                    <p class="desc">{{item.description}}</p>
                    <!-- <span class="date">发布日期：{{ item.releaseTime }}</span> -->

                    <div class="link-date">
                        <span class="date">
                            <Icon type="ios-stopwatch-outline" size="15" style="margin-right: 6px;"></Icon>{{ item.releaseTime }}
                        </span>
                        <span class="link">查看详情</span>
                    </div>

                </div>
            </li>
        </ul>
        <div class="page">
            <Page :total="total" show-total :page-size="searchParams.pageSize" :current="searchParams.page" @on-change="pageChange"></Page>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        list: {
            type: Array,
            default: [],
        },
        searchParams: {
            type: Object,
            default: {},
        },
        total: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {};
    },
    methods: {
        pageChange(val) {
            this.$emit("pageChange", val);
        },

        toDetail(item) {
            switch (item.type) {
                case "1": {
                    window.open(item.url);
                    break;
                }
                case "2": {
                    let routeUrl = this.$router.resolve({
                        path: "/index/wumei/NewsDetail",
                        query: {
                            id: item.id,
                            activeName: item.dictName
                        },
                    });
                    window.open(routeUrl.href, "_blank");
                    break;
                }
                case "3": {
                    window.open(item.fileUrl);
                    break;
                }
            }
        },
    },
};
</script>

<style scoped>
.pic-news .list .item {
    border-bottom: 1px #dcdcdc dashed;
    position: relative;
    cursor: pointer;
    display: flex;
    padding-top: 20px;
    padding-bottom: 20px;
}

.pic-news .list .item img {
    width: 200px;
    height: 134px;
    overflow: hidden;
    border-radius: 2px;
}

.pic-news .list .item .info {
    flex: 1;
    margin-left: 22px;
}

.pic-news .list .item .title {
    color: #323232;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    max-height: 46px;
    overflow: hidden;
    word-break: break-all;
    margin-right: 0.3rem;
    transition: all 0.2s;
    -webkit-transition: all 0.2s;
    -moz-transition: all 0.2s;
    -ms-transition: all 0.2s;
    -o-transition: all 0.2s;
    font-size: 16px;
}

.pic-news .list .item .title:hover {
    color: #df4501;
}

.pic-news .list .item .desc {
    margin-top: 10px;
    font-size: 13px;
    color: #787878;
    line-height: 22px;
    letter-spacing: 0;
    text-align: justify;
    max-height: 60px;
    overflow: hidden;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}

.pic-news .list .item .link {
    line-height: 26px;
    display: inline-block;
    font-size: 12px;
    padding: 0 10px;
    min-width: 86px;
    text-align: center;
    color: #e32322;
    background: #fcfcfc;
    border: 1px solid #f0f0f0;
}

.pic-news .list .item .date {
    /* color: #095494; */
    color: #999;
    font-size: 12px;
    line-height: 18px;
    /* color: #a7a7a7; */
}

.pic-news .list .item .link-date {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 18px;
}

.pic-news .list .item:hover .title {
    color: #df4501;
}
</style>


// WEBPACK FOOTER //
// src/components/wumei/PicList.vue